export const getOptionsFromParams = <T = { [k: string]: any }>(
  values: T[] = [],
  value?: keyof T | ((v: T) => any),
  label?: keyof T | ((v: T) => any)
): { value: string; label: string }[] => {
  return Array.from(values).map((v) => {
    return {
      value: typeof value === 'function' ? value(v) : v[value!],
      label: typeof label === 'function' ? label(v) : v[label!],
    };
  });
};

export const getFromIdNomeOptions = (
  values: { id: number | string; nome: string }[]
) => {
  return getOptionsFromParams(values, 'id', 'nome');
};

export const getOptionsFromStringArray = (values: string[] = []) => {
  return Array.from(values).map((v) => {
    return {
      value: v,
      label: v,
    };
  });
};
